import axios from 'axios';
import store from '../store';
import { ADMIN_LOGOUT } from '../actions/types';

// Instancia de axios DEDICADA al panel admin.
// Aislada de backendAxios para que la sesión de cliente y la de admin
// no se pisen (token propio `adminToken`) y para redirigir a /admin/login en 401.
const adminAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Inyecta el token de admin en cada petición (leído fresco de localStorage).
adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers['x-auth-token'] = token;
  }
  return config;
});

// 401/403 → cierra sesión de admin y manda al login admin.
adminAxios.interceptors.response.use(
  (response) => {
    // Renovación silenciosa del token de admin (expira en 1 día)
    const renovado = response.headers['x-token-refresh'];
    if (renovado) localStorage.setItem('adminToken', renovado);
    return response;
  },
  (error) => {
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      const teniaToken = !!localStorage.getItem('adminToken');
      localStorage.removeItem('adminToken');
      store.dispatch({ type: ADMIN_LOGOUT });
      if (teniaToken && window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default adminAxios;
